import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
import dateBarChart from '@/components/bigDataChart/dateBarChart';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterSameChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '590px'
    },
    reportType: {
      type: String,
      default: ''
    },
    quantum: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    initNum: {
      type: Number,
      default: 0
    },
    siteId: {
      type: String,
      default: ''
    },
    selectType: {
      type: String,
      default: ''
    }
  },
  components: {
    dateBarChart: dateBarChart
  },
  data: function data() {
    return {
      dataSource: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.selectType) {
      this.url = '/online/st' + this.selectType + '/chart';
      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteType') {
          _this.url = '/online/st' + _this.selectType + '/chart';
        }
      });
    } else {
      this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteType') {
          _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
        }
      });
    }
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(monitorType, reportType) {
      var _this2 = this;

      var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!this.$refs.chart5) return;

      if (!this.startTime || !this.endTime) {
        this.$message.error('请选择时间');
        return;
      }

      var that = this;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        scopeId: this.siteId,
        quantum: this.quantum,
        type: '5',
        dataType: reportType,
        column: 'data_time',
        order: 'asc'
      };
      var options = [];
      getAction(this.url, params).then(function (res) {
        if (res.success) {
          var data = {
            seriesData: [],
            source: [],
            factors: []
          };
          that.dataSource = JSON.parse(JSON.stringify(res.result));
          var dateTime = ['日期'];
          res.result.records.forEach(function (v, i) {
            dateTime.push(v.dataTime);
            data.seriesData.push({
              type: 'bar'
            });
          });
          var dataList = new Array(res.result.query.factors.length).fill([]);
          res.result.query.factors.forEach(function (item, index) {
            options.push({
              label: item.alias || item.title,
              value: item.code,
              categoryName: item.categoryName
            });
            dataList[index] = [item.alias || item.title];
            res.result.records.forEach(function (v, i) {
              dataList[index].push(v.factor[item.code].value);
            });
          });
          data.source = [dateTime];
          dataList.forEach(function (v) {
            data.source.push(v);
          });
          console.log('data', data);

          if (state) {
            _this2.$nextTick(function () {
              that.$parent.$parent.$refs.colControl.firstState = true;
            });
          }

          that.$emit('factorOption', options); // that.$refs.chart5.initDateBarChart(data)
        }
      });
    },
    changeChartInit: function changeChartInit(data, type, factors) {
      this.$refs.chart5.initDateBarChart(data, type, factors);
    }
  },
  watch: {
    siteId: function siteId() {
      this.querySewageQuotaList(this.monitorType, this.reportType);
    },
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.querySewageQuotaList(this.monitorType, this.reportType);
      }
    },
    initNum: function initNum() {
      this.querySewageQuotaList(this.monitorType, this.reportType, false);
    }
  }
};